import React from "react";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
interface NewsCardProps {
  urlImage: string;
  title: string;
  description: string;
  dateNews: string;
  id: number;
}
const CardNews = ({ ...props }: NewsCardProps) => {
  const navigate = useNavigate();

  const handleCardClick = (id: number) => {
    navigate("/news/details", { state: { id } });
  };
  return (
    <div className="full-news-card">
      <div className="news-card">
        <img src={props?.urlImage} alt="news" className="news-card-image" />
        <div className="news-card-date">{props?.dateNews}</div>
        <div className="news-card-description">
          {parse(props?.description)}
        </div>
      </div>
      <div className="button-div" onClick={() => handleCardClick(props?.id)}>
        <button className="news-card-button">اقرأ المزيد</button>
      </div>
    </div>
  );
};

export default CardNews;
